export default __webpack_public_path__ + "static/media/style0.3c014870.svg";